import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Api } from "../../services/api";
import { Http, Response } from "@angular/http";
import { Poster } from "../../services/poster";
import { ShareCard } from "../../services/sharecard";

/**
 * Generated class for the DtbSharePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "dtbshare/:token",
})
@Component({
  selector: "page-dtb-share",
  templateUrl: "dtb-share.html",
})
export class DtbSharePage {
  imageUrl = "";

  constructor(
    public navCtrl: NavController,
    private api: Api,
    private http: Http,
    public navParams: NavParams,
    private poster: Poster,
    private shareCard: ShareCard
  ) {}

  ionViewDidEnter() {
    document.title = "我邀您一起 在线学物理";

    const getPosterFileName = () => {
      return new Promise((resolve, reject) => {
        if (this.navParams.data.token.startsWith("___")) {
          const parsedData = JSON.parse(
            urlSafeBase64Decode(this.navParams.data.token.replace("___", ""))
          );
          this.api.getSharePoster(parsedData).then((data) => {
            this.imageUrl = this.poster.getUrl(data.fileName);
            resolve();
          });
        } else {
          this.http
            .get(
              `https://server.datongbei.com/api/wx-get-custom-poster-new?data=${this.navParams.data.token}`,
              {}
            )
            .subscribe(
              (res: Response) => {
                let body = res.json();
                this.imageUrl = `https://server.datongbei.com/posters/${body.fileName}`;
                resolve();
              },
              (error: Response | any) => {
                reject(error.json() || {});
              }
            );
        }
      });
    };

    getPosterFileName().then(() => {
      this.shareCard.share({
        title: "我邀您一起 在线学物理",
        desc:
          "大同杯物理学习网站，开设各种物理+竞赛+自招课程。新用户7折，快来看看吧！",
        link: location.href,
        imgUrl: this.imageUrl,
      });
    });
  }
}

function urlSafeBase64Decode(value) {
  return atob(
    value.split(".").join("=").split("-").join("/").split("_").join("+")
  );
}



// WEBPACK FOOTER //
// ./src/pages/dtb-share/dtb-share.ts